export type StorageUploadingProcess = {
  progress: number | null
  files: File[]
  error: string | null
};

export type IStorageAccess = {
  isStorageActive: boolean | null
  loading: boolean,
  error: string | null
  uploading: StorageUploadingProcess
};

export enum ActionTypes {
  SET_IS_ACTIVE = 'storage:set-is-active',
  SET_LOADING = 'storage:set-loading',
  SET_ERROR = 'storage:set-error',
  START_UPLOAD = 'storage:start-upload',
  SET_PROGRESS = 'storage:set-progress',
  STOP_UPLOAD = 'storage:stop-upload',
  SET_UPLOAD_ERROR = 'storage:set-upload-error',
}
